angular.module('gym.tasks').factory('TaskTypeService', ["$modal", "TaskTypes", function($modal, TaskTypes) {
  return {
    new: function() {
      return TaskTypes.customGET('new');
    },
    reload: function() {
      return TaskTypes.getList();
    },
    find: function(taskTypes, id) {
      return taskTypes.doGET(id);
    },
    save: function(taskType, taskTypeName) {
      var params;
      params = {
        name: taskTypeName,
        color: taskType.color
      };
      if (taskType.id) {
        return taskType.doPUT(params);
      } else if (!taskType.id) {
        return taskType.doPOST(params);
      }
    },
    delete: function(taskType) {
      return taskType.doDELETE();
    }
  };
}]);
